import { FC } from "react";
import { SocialLinks } from "./SocialLinks";

const Footer: FC = () => {
  return (
    <footer className=" footer p-3 glass backdrop-blur-sm">
      <div className=" mx-auto my-5 max-w-6xl">
        &copy; {new Date().getFullYear()} Anil Maharjan
      </div>
      <SocialLinks hideLabels />
    </footer>
  );
};

export default Footer;
